
<section class="users-edit">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- Nav-tabs -->
              <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs justify-content-left">
                <li [ngbNavItem]="1">
                  <a ngbNavLink class="nav-link d-flex align-items-center">
                    <i class="ft-user mr-1"></i>
                    <span class="d-none d-sm-block">Account</span>
                  </a>
                  <ng-template ngbNavContent>
                    <!-- Account content starts -->
                    <div class="mt-2" id="account">
                      <form >
                        <div class="row">
                          <div class="col-md-6">
                             <fieldset class="form-group">
                              <label>Name<span class="required_field">*</span></label>
                               <input type="text" class="form-control"   [(ngModel)]="businessData.name" [ngModelOptions]="{standalone: true}" id="name"  placeholder="Enter  Name"> 
                            </fieldset> 
                            <fieldset class="form-group">
                              <label>About</label>
                              <textarea class="form-control" name="about" id="about" placeholder="Enter about" cols="30" rows="3" [(ngModel)]="businessData.about" [ngModelOptions]="{standalone: true}"></textarea>
                            </fieldset>
                            <fieldset class="form-group">
                              <label for="address">Address</label>
                              <input type="text" class="form-control"   [(ngModel)]="businessData.address" [ngModelOptions]="{standalone: true}" id="address"  placeholder="Enter Address">
                            </fieldset>  
                            <fieldset class="form-group">
                              <label for="email">Email</label>
                              <input type="text" class="form-control"   [(ngModel)]="businessData.email" [ngModelOptions]="{standalone: true}" id="address"  placeholder="Enter Address">
                            </fieldset> 
                            <fieldset class="form-group">
                              <label for="durations">Website</label>
                              <input type="text" class="form-control"   [(ngModel)]="businessData.website" [ngModelOptions]="{standalone: true}" id="durations"  placeholder="Enter website">
                            </fieldset>  
                            <fieldset class="form-group">
                                <label>Phone Number</label>
                                <input type="text" class="form-control"   [(ngModel)]="businessData.phone" [ngModelOptions]="{standalone: true}"  placeholder="e.g. 1234-567-890"
                                mask="0000-000-000" minlength="10" type="text"
                                class="form-control" id="phone">
                              </fieldset>
                              <fieldset class="form-group">
                                <label for="type">Business type</label>
                                <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                                placeholder="Select business type" [multiple]="true"  [(ngModel)]="selected_type"
                                [ngModelOptions]="{standalone: true}" (change)='getBusinessId($event)'
                               >
                              </ng-select>
                              </fieldset>
                              <fieldset class="form-group">
                                <label for="facebook_url">Facebook Url</label>
                                <input type="text" class="form-control"   [(ngModel)]="businessData.facebook_url" [ngModelOptions]="{standalone: true}" id="address"  placeholder="Enter Address">
                              </fieldset>
                              <fieldset class="form-group">
                                <label for="linked_url">Linked Url</label>
                                <input type="text" class="form-control"   [(ngModel)]="businessData.linked_url" [ngModelOptions]="{standalone: true}" id="address"  placeholder="Enter Address">
                              </fieldset>
                              
                             
                                                 
                        </div>                        
                          <div class="col-md-6">
                            <fieldset class="form-group">
                              <label>Refrences</label>
                              <quill-editor [(ngModel)] ="businessData.refrences" [ngModelOptions]="{standalone: true}" (onContentChanged)="setFocus($event)"></quill-editor>
                            </fieldset>
                              <fieldset class="form-group">
                                <label for="admin_notes">Admin Notes</label>
                                 <textarea id="hidden-label-form-6" rows="5" [(ngModel)]="businessData.admin_notes" [ngModelOptions]="{standalone: true}" class="form-control " name="comment2" placeholder="description"></textarea>
                              </fieldset> 
                            <fieldset class="form-group">
                              <label for="durations">Notes</label>
                              <textarea id="hidden-label-form-6" rows="5" [(ngModel)]="businessData.notes" [ngModelOptions]="{standalone: true}" class="form-control " name="comment2" placeholder="notes"></textarea>
                            </fieldset> 
                          
                             

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                              <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">Submit</button>
                              <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                            </div>
                         </div>
                        </div>
                       
                      </form>
                      <!-- Account form ends -->
                    </div>
                    <!-- Account content ends -->
                  </ng-template>
                </li>
            
              </ul>
              <div class="tab-content">
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
